import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getEvents } from '../services/eventService';

const schedule = [
  { time: '2:00 PM', label: 'Registration & Check-in', icon: '📋' },
  { time: '3:00 PM', label: 'Shotgun Start', icon: '⛳' },
  { time: '5:00 PM', label: 'Golf Concludes', icon: '🏌️' },
  { time: '5:30 PM', label: 'Cocktail Hour & Appetizers', icon: '🍹' },
  { time: '6:30 PM', label: 'Dinner Service', icon: '🍽️' },
  { time: '7:30 PM', label: 'Awards & Prizes', icon: '🏆' },
];

const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
};

const TournamentInfoPage = () => {
  const navigate = useNavigate();
  const [nextEvent, setNextEvent] = useState(null);

  useEffect(() => {
    getEvents().then((events) => {
      if (!events || events.length === 0) return;
      const today = new Date().toISOString().split('T')[0];
      const upcoming = events
        .filter((e) => e.date >= today)
        .sort((a, b) => a.date.localeCompare(b.date));
      setNextEvent(upcoming[0] || events.sort((a, b) => a.date.localeCompare(b.date))[0]);
    }).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="tournament-page" id="tournament-content">

      {/* Event Details Bar */}
      <div className="event-details-bar">
        <div className="event-detail-item">
          <span className="event-detail-icon">📅</span>
          <div>
            <div className="event-detail-label">Next Event</div>
            <div className="event-detail-value">
              {nextEvent ? formatDate(nextEvent.date) : 'Every Friday'}
            </div>
          </div>
        </div>
        <div className="event-detail-divider" />
        <div className="event-detail-item">
          <span className="event-detail-icon">⏰</span>
          <div>
            <div className="event-detail-label">Shotgun Start</div>
            <div className="event-detail-value">{nextEvent?.time || '3:00 PM'}</div>
          </div>
        </div>
        <div className="event-detail-divider" />
        <div className="event-detail-item">
          <span className="event-detail-icon">📍</span>
          <div>
            <div className="event-detail-label">Location</div>
            <div className="event-detail-value">{nextEvent?.location || 'Verrado Golf Club'}</div>
          </div>
        </div>
        <div className="event-detail-divider" />
        <div className="event-detail-item">
          <span className="event-detail-icon">🏌️</span>
          <div>
            <div className="event-detail-label">Format</div>
            <div className="event-detail-value">9 Holes · Scramble</div>
          </div>
        </div>
      </div>

      {/* Main Grid */}
      <div className="tournament-grid">

        {/* Schedule */}
        <div className="tournament-card">
          <div className="tournament-card-header">
            <span className="tournament-card-icon">🗓️</span>
            <h2>Day Schedule</h2>
          </div>
          <div className="schedule-list">
            {schedule.map((item, i) => (
              <div key={i} className="schedule-item">
                <div className="schedule-line">
                  <div className="schedule-dot" />
                  {i < schedule.length - 1 && <div className="schedule-connector" />}
                </div>
                <div className="schedule-content">
                  <span className="schedule-time">{item.time}</span>
                  <span className="schedule-icon">{item.icon}</span>
                  <span className="schedule-label">{item.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Registration & Pricing */}
        <div className="tournament-card">
          <div className="tournament-card-header">
            <span className="tournament-card-icon">💰</span>
            <h2>Registration</h2>
          </div>

          <div className="pricing-single">
            <div className="pricing-badge-large">
              {nextEvent?.fee ? `$${nextEvent.fee}` : '$300'}
            </div>
            <div className="pricing-type">Per Person</div>
            <div className="pricing-desc">Registration fees go to charity 💚</div>
          </div>

          <button className="register-cta" onClick={() => navigate('/events', { state: { autoOpenFirst: true } })}>
            Register Now →
          </button>
        </div>

        {/* Package Details */}
        <div className="tournament-card" style={{gridColumn: '1 / -1'}}>
          <div className="package-highlight">
            <p className="package-headline">
              {nextEvent?.fee ? `$${nextEvent.fee}` : '$300'} PER PERSON INCLUDES YOUR 5 FOR THE FIGHT DONATION, DINNER BUFFET, CUSTOM TRAVIS MATHEW POLO AND HAT, ROUND OF GOLF.
            </p>
            <p className="package-details">EVERYONE HAS BEEN TOUCHED BY CANCER, AND THERE'S NO PREPARING FOR IT WHEN IT HITS. THROUGH OUR PARTNERSHIP WITH 5 FOR THE FIGHT, LAYTON ENCOURAGES ALL EMPLOYEES, ARCHITECTS, TRADE PARTNERS, AND THE COMMUNITY AT LARGE TO JOIN THE FIGHT AND HELP US FUND CANCER RESEARCH.</p>
          </div>
        </div>

      </div>

      {/* Contact */}
      <div className="tournament-contact">
        <span>📍 {nextEvent?.location || 'Verrado Golf Club'}</span>
      </div>

    </div>
  );
};

export default TournamentInfoPage;
